// Story 65.68 (RC-176): colunas do export que nunca viram campo do agendamento e o sinal de
// que a coluna escolhida para Hora de início traz data e hora juntas. Mesma regra na tela
// (seletor e aviso) e na API (guarda do mapeamento e correção do relatório).
/** Registro do sistema anterior: quando e quem mexeu no agendamento, não o atendimento. */
export const APPOINTMENTS_IGNORED_COLUMNS = ['Data Ação', 'Executado por'];
export const IGNORED_COLUMN_REASON = 'registro do sistema anterior (quando e quem mexeu no agendamento)';
export const START_TIME_DATETIME_WARNING = 'Essa coluna tem data e hora juntas — parece ser quando o agendamento foi feito, não o horário do atendimento.';
export const START_TIME_DATE_HAS_TIME_HINT = 'A coluna da Data já traz a hora: deixe Hora de início sem coluna.';
export const START_TIME_DATETIME_REASON = 'a coluna escolhida para Hora de início tem data e hora juntas';
export const START_TIME_COLUMN_CORRECTION = 'Volte em Conferir as colunas e escolha outra coluna para Hora de início (ou deixe sem coluna se a Data já traz a hora)';
function columnKey(header) {
    return header
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}
const IGNORED_KEYS = new Set(APPOINTMENTS_IGNORED_COLUMNS.map(columnKey));
export function isDeclaredIgnoredColumn(header) {
    return IGNORED_KEYS.has(columnKey(header));
}
const DATE_AND_TIME_RE = /\d{1,4}[/.-]\d{1,2}[/.-]\d{1,4}(?:\s+|T)\d{1,2}:\d{2}/;
export function looksLikeDateAndTime(value) {
    return DATE_AND_TIME_RE.test((value ?? '').trim());
}
/** true quando alguma linha da amostra traz data e hora juntas nessa coluna. */
export function columnHasDateAndTime(rows, column) {
    if (!column)
        return false;
    return rows.some((row) => looksLikeDateAndTime(row[column]));
}
//# sourceMappingURL=appointment-columns.js.map